import FilesLayout from "files/FilesLayout";

function ManageFiles(props: any) {

    return (
        <FilesLayout props={props} />
    );
}

export default ManageFiles;